import { render, staticRenderFns } from "./onlineConsulting.vue?vue&type=template&id=71f59cf3&"
import script from "./onlineConsulting.vue?vue&type=script&lang=js&"
export * from "./onlineConsulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports